import { Phone, Mail, MapPin } from "lucide-react";
import { TID } from "@/lib/testIds";

const items = [
  {
    Icon: MapPin,
    label: "Chennai, India",
    value: "Head Office",
    href: null,
    tid: TID.contact.address,
  },
  {
    Icon: MapPin,
    label: "London, United Kingdom",
    value: "Branch Office",
    href: null,
    tid: `${TID.contact.address}-uk`,
  },
  {
    Icon: Phone,
    label: "Phone",
    value: "+91 98840 03957",
    href: "tel:+919884003957",
    tid: TID.contact.phone,
  },
  {
    Icon: Mail,
    label: "Email",
    value: "info@jmrgloballogistics.com",
    href: "mailto:info@jmrgloballogistics.com",
    tid: TID.contact.email,
  },
];

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid={TID.contact.section}
      className="bg-white border-t border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12 md:mb-16">
          <div className="md:col-span-7 reveal">
            <p className="text-sm font-bold uppercase tracking-[0.25em] text-sky-600 mb-4">
              Contact Us
            </p>
            <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter text-slate-900 leading-[1.02]">
              Let&apos;s move<br />
              <span className="text-slate-400">your cargo.</span>
            </h2>
          </div>
          <div className="md:col-span-5 flex items-end reveal">
            <p className="text-slate-600 text-lg md:text-xl">
              Reach out through any channel below — our team responds quickly across timezones.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-l border-t border-slate-200">
          {items.map((it) => {
            const Body = (
              <div
                data-testid={it.tid}
                className="border-r border-b border-slate-200 p-6 md:p-8 h-full bg-white hover:bg-sky-50/60 transition-colors group"
              >
                <span className="inline-flex items-center justify-center w-12 h-12 bg-blue-600 text-white group-hover:bg-sky-400 group-hover:text-blue-900 transition-colors mb-5">
                  <it.Icon className="w-5 h-5" strokeWidth={1.6} />
                </span>
                <p className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-2">{it.label}</p>
                <p className="font-display font-semibold text-lg md:text-xl text-slate-900 leading-snug">
                  {it.value}
                </p>
              </div>
            );
            return it.href ? (
              <a key={it.label} href={it.href} target={it.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer">
                {Body}
              </a>
            ) : (
              <div key={it.label}>{Body}</div>
            );
          })}
        </div>

        {/* Promise band */}
        <div className="mt-16 md:mt-24 bg-blue-900 text-white p-10 md:p-16 border border-blue-800 reveal">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-7">
              <p className="text-sm font-bold uppercase tracking-[0.25em] text-sky-400 mb-3">Our Promise</p>
              <h3 className="font-display font-black text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
                Every shipment represents<br />
                your business, your customers,<br />
                and your <span className="text-sky-400">reputation.</span>
              </h3>
            </div>
            <div className="md:col-span-5">
              <p className="text-slate-200 text-base md:text-lg leading-relaxed">
                That is why we are committed to delivering every shipment with precision, reliability, and care — because your success is our priority.
              </p>
              <p className="mt-6 font-mono text-xs uppercase tracking-widest text-sky-400">
                Moving Global Trade Forward.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
